// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__xb5f_","file":"styles_file__1UpSR"};